
import { Module, utils } from '../core';

import showPosition from './commands/showPosition';

export default class ModuleMultiScene extends Module {

    constructor() {
        super('multiscene');
    }

    async init(options) {
        super.init(options);

        let moduleOptions = this.getOptions();

        let urlBase = moduleOptions.urlBase || 'https://api.multiscenecloud.com';
        let version = moduleOptions.version || 'v1.14';

        let scripts = [
            urlBase + `/client/${version}/PointCloudCore.js`,
            urlBase + `/client/${version}/MultiSceneCore.js`
        ];

        await utils.loadScripts(scripts);
    }

    initCommands() {
        this.addCommand(showPosition);
    }
}
